"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _radio = _interopRequireDefault(require("britive-design-system/core/components/radio"));

var _constants = require("./constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ResourcePermission = function ResourcePermission(_ref) {
  var validationHook = _ref.validationHook;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.mainContainer
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.addPolicyFieldWrapper
  }, /*#__PURE__*/_react.default.createElement(_radio.default, {
    defaultValue: "".concat(validationHook.values.accessLevel === 'view'),
    direction: "vertical",
    label: 'Permissions',
    name: "resourcePermission",
    options: _constants.promptData,
    onChange: function onChange(e) {
      return validationHook.handleChange(validationHook.names.accessLevel, e.target.value === 'true' ? 'view' : 'manage');
    }
  })));
};

ResourcePermission.propTypes = {
  validationHook: _propTypes.default.object,
  translatedStrings: _propTypes.default.object
};
var _default = ResourcePermission;
exports.default = _default;